// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__tY_8O","empty":"ModalGraph_empty__27ZDz"};